import React, {useEffect} from "react";
import {Routes, Route} from "react-router-dom";
import SealType from "../../layout/product/seal/SealType";
import AddSealType from "../../layout/product/seal/AddSealType";
import PriceLayout from "../../layout/product/PriceLayout";

const SealTypePage = () => {
    useEffect(() => {
        return () => {
            localStorage.removeItem("seselectedId");
            localStorage.removeItem("seitemOffset");
            localStorage.removeItem("seforcePage");
        };
    }, []);

    return (
        <>
            <Routes>
                <Route path="/" element={<SealType/>}/>
                <Route path="/add" element={<AddSealType/>}/>
                <Route path="/update/:id" element={<AddSealType/>}/>
                <Route path="/price/:id/:name" element={<PriceLayout/>}/>
            </Routes>
        </>
    );
};

export default SealTypePage;
